import { render } from "./TokenInfonNep17.vue?vue&type=template&id=67f5b990"
import script from "./TokenInfonNep17.vue?vue&type=script&lang=js"
export * from "./TokenInfonNep17.vue?vue&type=script&lang=js"

import "./TokenInfonNep17.vue?vue&type=style&index=0&id=67f5b990&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__